/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';

import { TApiLoopsInProgressStatus } from '../../services/logs.store';

// type defines the kinds of banners this component can display.
export type LogsBannerType = 'loading' | 'warning' | 'danger' | 'info' | 'success';

/**
 * @description
 *     Component to display an error message in the logs view.
 * @author Zhiqian Liu, Yogesh Patil
 */
@Component({
    selector: 'logs-errors',
    templateUrl: './logs-errors.component.html',
})
export class LogsErrorsComponent implements OnInit {
    /**
     * Type of banner to display ('loading', 'warning', 'danger', 'info').
     */
    @Input()
    public alertType: LogsBannerType;

    /**
     * Observable that controls the overall visibility of the banner.
     */
    @Input()
    public show = false;

    @Input()
    public loadingStatus?: TApiLoopsInProgressStatus;

    @Input()
    public loadingMessageLabel?: string;

    @Input()
    public graphLoadingMessageLabel?: string;

    @Input()
    public tableLoadingMessageLabel?: string;

    @Input()
    public timeoutMessageLabel?: string;

    @Input()
    public timeoutsDocLink?: string;

    @Input()
    public learnMoreLinkText?: string;

    @Input()
    public refreshLogsLabelText?: string;

    @Input()
    public errorMessage?: string;

    @Input()
    public actionLabel?: string;

    @Input()
    public infoMessageLabel?: string;

    @Input()
    public successMessageLabel?: string;

    @Input()
    public size = 'sm';

    public closable: boolean;

    @Output()
    public onClose = new EventEmitter<void>();

    @Output()
    public onRefresh = new EventEmitter<void>();

    @Output()
    public onAction = new EventEmitter<void>();

    public ngOnInit(): void {
        this.closable = this.onClose?.observers?.length > 0;
    }

    public handleCloseClick(): void {
        this.onClose.emit();
    }

    public handleRefreshClick(): void {
        this.onRefresh.emit();
    }

    public handleActionClick(): void {
        this.onAction.emit();
    }
}
